module.exports = __webpack_public_path__ + "media/img/event/speakers/John-Fosbrook-cb4cb73d8f1e914fa32d351c49f97b09.jpg";